<template>  
<!-- NavBar -->
  <NavBar />
  <LoadStatus/>
  <Wave v-if="this.$store.getters.GetBlock.animWave && this.$store.getters.Animation.waves"/>
  <Cells v-if="this.$store.getters.GetBlock.animCells && this.$store.getters.Animation.cells" /> 
  <Net v-if="this.$store.getters.GetBlock.animNet && this.$store.getters.Animation.net" /> 
  <Birds v-if="this.$store.getters.GetBlock.animBirds && this.$store.getters.Animation.birds" /> 
  <Top v-if="this.$store.getters.GetBlock.animTop && this.$store.getters.Animation.top" /> 
  <Cloud v-if="this.$store.getters.GetBlock.animCloud && this.$store.getters.Animation.cloud" /> 
  <Cloud2 v-if="this.$store.getters.GetBlock.animCloud2 && this.$store.getters.Animation.cloud2" /> 
  <Fluid v-if="this.$store.getters.GetBlock.animFluid && this.$store.getters.Animation.fluid" /> 
  
  <div class="home">
     
    <ScDir/>
    <OrgCom/>
    <GeneralDate/>
    <Programm/>
  </div>
  <Footer/>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import NavBar from '@/components/NavBar.vue'
import LoadStatus from '@/components/LoadSatus.vue'
import Wave from '@/components/AnimateBlockWave.vue'
import Cells from '@/components/AnimateBlockCells.vue'
import Net from '@/components/AnimateBlockNet.vue'
import Birds from '@/components/AnimateBlockBirds.vue'
import Top from '@/components/AnimateBlockTop.vue'
import Cloud from '@/components/AnimateBlockCloud.vue'
import Cloud2 from '@/components/AnimateBlockCloud2.vue'
import Fluid from '@/components/AnimateBlockFluid.vue'
import ScDir from '@/components/SciendirBlock.vue'
import OrgCom from '@/components/OrgcomBlock.vue'
import GeneralDate from '@/components/TimelineBlock.vue'
import Footer from '@/components/FooterBlock.vue'
import Programm from '@/components/ProgramBlock.vue'

export default {
  name: 'HomeView',
  components: {
    //HelloWorld,
    NavBar,
    Wave,
    Cells,
    Net,
    Birds,
    Top,
    Cloud,
    Cloud2,
    Fluid,
    LoadStatus,
    ScDir,
    OrgCom,
    GeneralDate,
    Footer,
    Programm
  }  
}



</script>
